<template>
  <Main>
    <v-container>
      <v-card class="mx-auto">
        <v-card-text>
          <p class="display-1 text--primary">
            Upload New Role
            <v-btn small color="warning" @click="downloadCSV()">Download Template</v-btn>
          </p>
          <div class="text--primary">
            <!-- {{ this.SELECTED_MONTH_PERIOD + " - " + this.SELECTED_YEAR_PERIOD + " - " + this.SELECTED_BRANCH}} -->
            <!-- {{ this.VSELECT_BRANCH }} -->
            <v-row>
              <v-col md="12" sm="12">
                <!-- {{ "CSV : " + this.JSON_FILE_UPLOAD }} -->
                <FilePond
                  name="test"
                  ref="pond"
                  class-name="my-pond"
                  label-idle="Click or Drop files here..."
                  accepted-file-types="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv, application/csv"
                  :files="this.FILE_UPLOAD"
                  :init="handleFilePondInit"
                  v-on:updatefiles="handleFilePondUpdateFile"
                  v-on:removefile="handleFilePondRemoveFile"
                />
              </v-col>
              <v-col md="12" sm="12">
                <v-btn
                  small
                  color="warning"
                  class="mb-3 float-right"
                  @click="confirmModal(submitUpload)"
                  >Submit Uploaded File</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text
          >It will submit all data which is imported to database. Please give confirmation
          before you submit.</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import XLSX from "xlsx";
import moment from "moment";

// Import the plugin code
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

// Import Vue FilePond
import vueFilePond, { setOptions } from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

setOptions({
  allowMultiple: false,
});

const JSON_FOR_DOWNLOAD = [
  {
    POSITION_CODE: "",
    EMPLOYEE_TYPE_CODE: "",
    EMPLOYEE_TITLE_CODE: "",
    ORG_ID: "",
    BRANCH_CODE: "",
    CSO_CODE: "NA",
    SUPERVISOR: "",
    EMAIL_SUPERVISOR: "",
    SECONDARY_POSITION: "Y/N",
    ADDITIONAL_TYPE: "NA",
    START_DATE: "YYYY-MM-DD",
    END_DATE: "YYYY-MM-DD",
  },
];

export default {
  components: {
    Main,
    FilePond,
  },
  data() {
    return {
      methodAction: "",
      isOpenModalConfirm: false,
      FILE_UPLOAD: [],
      JSON_FILE_UPLOAD: [],
      search: "",
      dtLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      isLoading: false,
    };
  },
  methods: {
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    handleFilePondInit() {},
    handleFilePondUpdateFile(file) {
      let self = this;
      let counter = true;

      const UPLOADED_CSV = file.map((fileItems) => fileItems.file);
      const userData = JSON.parse(localStorage.getItem("userData"));

      var files = UPLOADED_CSV,
        f = files[0];

      if (f.type == "application/vnd.ms-excel") {
        if (f) {
          var reader = new FileReader();
          reader.onload = (e) => {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {
              type: "array",
              cellDates: true,
            });
            let sheetName = workbook.SheetNames[0];
            /* DO SOMETHING WITH workbook HERE */
            let worksheet = workbook.Sheets[sheetName];
            const XLSXJSON = XLSX.utils.sheet_to_json(worksheet);
            if (self.JSON_FILE_UPLOAD < 1) {
              for (let XLSXJSONDATA of XLSXJSON) {
                // console.log(XLSXJSONDATA);
                if (
                  XLSXJSONDATA.BRANCH_CODE != undefined &&
                  XLSXJSONDATA.EMPLOYEE_TITLE_CODE != undefined &&
                  XLSXJSONDATA.EMPLOYEE_TYPE_CODE != undefined &&
                  XLSXJSONDATA.START_DATE != undefined &&
                  XLSXJSONDATA.ORG_ID != undefined &&
                  XLSXJSONDATA.POSITION_CODE != undefined &&
                  XLSXJSONDATA.EMAIL_SUPERVISOR != undefined &&
                  XLSXJSONDATA.SUPERVISOR != undefined &&
                  XLSXJSONDATA.END_DATE != undefined &&
                  XLSXJSONDATA.SECONDARY_POSITION != undefined &&
                  XLSXJSONDATA.CSO_CODE != undefined &&
                  XLSXJSONDATA.ADDITIONAL_TYPE != undefined
                ) {
                  // console.log(XLSXJSONDATA.START_DATE, " - ", new Date(XLSXJSONDATA.START_DATE), " - ", moment(new Date(XLSXJSONDATA.START_DATE)).add(1, "days").format("YYYY-MM-DD"))
                  // console.log(XLSXJSONDATA.END_DATE, " - ", new Date(XLSXJSONDATA.END_DATE), " - ", moment(new Date(XLSXJSONDATA.END_DATE)).add(1, "days").format("YYYY-MM-DD"))
                  self.JSON_FILE_UPLOAD.push({
                    rolePosCode: XLSXJSONDATA.POSITION_CODE,
                    typeCode: XLSXJSONDATA.EMPLOYEE_TYPE_CODE,
                    titleCode: XLSXJSONDATA.EMPLOYEE_TITLE_CODE,
                    orgId: XLSXJSONDATA.ORG_ID,
                    branchCode: XLSXJSONDATA.BRANCH_CODE,
                    CSOCode: XLSXJSONDATA.CSO_CODE ? XLSXJSONDATA.CSO_CODE : "NA",
                    supCode: XLSXJSONDATA.SUPERVISOR,
                    emailSup: XLSXJSONDATA.EMAIL_SUPERVISOR,
                    secondaryPosition: XLSXJSONDATA.SECONDARY_POSITION,
                    roleAddType: XLSXJSONDATA.ADDITIONAL_TYPE,
                    startDate: moment(new Date(XLSXJSONDATA.START_DATE)).format(
                      "YYYY-MM-DD"
                    ),
                    endDate: moment(new Date(XLSXJSONDATA.END_DATE)).format("YYYY-MM-DD"),
                    userIdUpdate: userData.USER_ID,
                  });
                }
              }
            }

            // console.log("JSON_FILE_UPLOAD : ", self.JSON_FILE_UPLOAD);

            if (self.JSON_FILE_UPLOAD.length < 1) {
              self.isLoading = false;
              self.isOpenModalConfirm = false;
              this.$refs.pond.removeFile();
              this.JSON_FILE_UPLOAD = [];
              self.showSnackbar("Template tidak sesuai.");
            }
          };
          reader.readAsArrayBuffer(f);
        }
      } else {
        this.isLoading = false;
        this.isOpenModalConfirm = false;
        this.$refs.pond.removeFile();
        this.JSON_FILE_UPLOAD = [];
        self.showSnackbar("Gunakan Template XLS");
      }
    },
    handleFilePondRemoveFile(error, file) {
      this.$refs.pond.removeFile();
      this.JSON_FILE_UPLOAD = [];
    },
    submitUpload() {
      console.log(this.JSON_FILE_UPLOAD);
      if (this.JSON_FILE_UPLOAD.length > 0) {
        this.isOpenModalConfirm = false;
        this.isLoading = true;
        this.$http
          .post("/structure/role/upload", this.JSON_FILE_UPLOAD, {
            headers: {
              "api-key": this.$apiKey
            }
          })
          .then((res) => {
            console.log(res.data);
            console.log(res.data.success);
            this.isLoading = false;
            if (res.data.success) {
              this.showSnackbar(
                "Success Import " +
                  res.data.data.SUCCESS +
                  " record(s) and failed for " +
                  res.data.data.FAIL +
                  " record(s)."
              );
              //   setTimeout(function () {
              //     location.reload();
              //   }, 1500);
            } else {
              this.showSnackbar(res.data.message);
            }
          })
          .catch((err) => {
            this.isLoading = false;
            this.showSnackbar(err.toString());
          });
      } else {
        this.isLoading = false;
        this.isOpenModalConfirm = false;
        this.showSnackbar("Template Tidak sesuai");
      }
    },
    downloadCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(JSON_FOR_DOWNLOAD);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Template Upload Role.xlsx"); // initiate a file download in browser
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
